<template>
  <p
    class="text-danger"
    style="font-size: 14px;
    color: red; margin: 0px;"
    v-html="error"
  >
  </p>
</template>

<script>
export default {
  props: ['error'],
};
</script>
